module.exports = "/_next/static/images/Ivan_Poclitari-b21ae6fa8d310d6962932e4dace66a4f.webp";